@import '../../../theme/colors';
@import '../../../theme/mixins';

.addRequestPage {
  display: flex;

  .requestContainer {
    display: flex;
    flex-direction: column;
    width: 66%;
    min-width: 757px;
    border-right: 1px solid $lightGrey;
    position: relative;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 13px;
    }

    .requestSection {
      display: flex;
      flex-direction: column;
      padding: 17px 240px 34px 0;
      margin-right: 17px;

      & > * {
        margin: 10px 0;
      }

      .submitButton {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 200px;
        height: 30px;
        margin-bottom: 0;
        margin-right: 22px;

        button {
          font-weight: 400;
          border-radius: 2px;
          font-family: var(--font-family__heading);
        }
      }

      .filesSection {
        margin: 15px 0;

        input {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }

        .files {
          @include label4;
          border: 1px dotted $lighterGrey;
          border-radius: 4px;
          width: 330px;
          display: flex;
          flex-direction: column;
          padding: 10px;
          margin: 10px 0;

          a {
            @include caption;
            color: $neutral-600;
            max-width: 95%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 5px 0;
          }

          a:hover {
            color: $lighterGrey;
          }

          a::after {
            content: '\A';
          }
        }
      }

      .header {
        margin-top: 13px;
      }

      .inputSection {
        margin-bottom: 35px;
      }

      .textfieldSection {
        margin-bottom: 51px;
      }

      .flexInputs {
        @extend .inputSection;
        display: flex;
      }
    }

    .loading {
      @extend .requestSection;
      opacity: 0.7;
      pointer-events: none;
    }

    .circularProgress {
      position: fixed;
      top: 60vh;
      left: 50%;
    }
  }

  .supportArea {
    display: flex;
    flex: 1;
    justify-content: center;
    font-family: var(--font-family__heading);

    .supportInfo {
      width: 367px;
      height: 176px;
      border: solid 2px #e5e9ea;
      padding: 20px 49px;

      h2 {
        font-size: 21px;
        font-weight: 400;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: normal;
        color: $navy;
      }

      h3 {
        font-size: 16px;
        font-weight: 400;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $neutral-600;
        margin-top: 30px;
      }

      a {
        text-transform: uppercase;
        color: $oceanBlue;
        text-decoration: none;
        font-size: 16px;
        font-weight: 400;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
      }
    }
  }
}
